export enum FV_SCANNER_STATUS {
  loading = 'loading',
  scanning = 'scanning',
  stopped = 'stopped',
  paused = 'paused'
}
